import { extractCollectionFromArangoId } from "../../common/AddEditEntityUtils";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import InternalEntityLink, {
  EntityReferenceLinkMode,
} from "./InternalEntityLink";
import renderDisplayText from "./RenderDisplayText";
import { Box, Typography } from "@mui/material";

// A version has at most one catalog entry, stored directly on the Version.
type CatalogEntry = { catalog_no?: string; catalog_entry?: string };

interface NodeEntity {
  published_id?: string;
  _id?: string;
  _key?: string;
  name?: string;
  name_attribute_pre?: string;
  name_primary?: string;
  name_attribute_post?: string;
  system_language_type?: string;
  _collection?: string;
  catalog?: CatalogEntry | null;
}

/** catalog_no for Tibetan Versions (catalog lives on the Version entity). */
const getCatalogNo = (
  entity: NodeEntity,
  collection: SystemEntityCollections
): string | undefined => {
  const isTibetanVersion =
    entity.system_language_type === "tibetan" &&
    collection === SystemEntityCollections.VERSION;

  if (!isTibetanVersion) return undefined;

  return entity.catalog?.catalog_no || undefined;
};

interface EntityReferenceComponentProps {
  id?: string;
  entity?: NodeEntity | null;
  entityCollection?: string;
  className?: string;
  /** Whether to append the catalog_no (Tibetan Version only). Defaults to true. */
  showCatalogNo?: boolean;
  linkMode?: EntityReferenceLinkMode;
}

export const EntityReferenceComponent = ({
  id,
  entity,
  entityCollection,
  className,
  showCatalogNo = true,
  linkMode = "edit",
}: EntityReferenceComponentProps) => {
  const collection: SystemEntityCollections | null =
    extractCollectionFromArangoId(entityCollection || entity?._collection) ||
    extractCollectionFromArangoId(entity?._id);

  const catalogNo =
    showCatalogNo && entity && collection
      ? getCatalogNo(entity, collection)
      : undefined;

  return (
    <Box className={className} id={id}>
      {entity && entity.published_id && collection ? (
        <>
          <InternalEntityLink
            {...entity}
            entityCollection={collection}
            linkMode={linkMode}
          >
            <Typography variant="body2">
              {renderDisplayText(entity, collection)}
            </Typography>
          </InternalEntityLink>
          {catalogNo && (
            <Typography variant="body2" component="span">
              {" "}({catalogNo})
            </Typography>
          )}
        </>
      ) : null}
    </Box>
  );
};

export default EntityReferenceComponent;
